export const STR_ERRORS = {
    WrongTypeForQuerySet: "Assigning the wrong query value! Queries can only be of type SDQuery<T>.",
    SDQRequestFormatRequiresActiveQuery: "SDQRequestFormatRequiresActiveQuery"
};
export const STR = {};
//# sourceMappingURL=index.js.map